// eslint-disable-next-line i18next/no-literal-string -- scope sentinel compared against a workspace id
export const ORG_WIDE_SCOPE = 'Organization';
